import { render, staticRenderFns } from "./paper-note-read-view.html?vue&type=template&id=05478ab2&scoped=true&external"
import script from "./paper-note-read-view.js?vue&type=script&lang=js&external"
export * from "./paper-note-read-view.js?vue&type=script&lang=js&external"
import style0 from "./paper-note-read-view.scss?vue&type=style&index=0&id=05478ab2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05478ab2",
  null
  
)

export default component.exports